import {
  Maybe as HygraphMaybe,
  Section as HygraphSection,
  Tracking,
} from '@/lib/types';

import { SectionProps } from '@/components/section';

import backgroundWidthTransformer from '@/hygraph/transformers/background-width.transformer';
import imageTransformer from '@/hygraph/transformers/image.transformer';
import lightColorTransformer from '@/hygraph/transformers/light-color.transformer';
import separatorTransformer from '@/hygraph/transformers/separator.transformer';

import CTATransformer from './cta.transformer';

export default function sectionTransformer(
  props: HygraphMaybe<HygraphSection> | undefined
): SectionProps | undefined {
  if (!props) {
    return undefined;
  }

  return {
    slug: props.slug || undefined,
    backgroundColor: lightColorTransformer(props.backgroundColor),
    backgroundImage: imageTransformer(props.backgroundImage),
    backgroundImageMobile: imageTransformer(props.backgroundImageMobile),
    backgroundWidth: backgroundWidthTransformer(props.backgroundWidth),
    separatorAfter: separatorTransformer(props.separatorAfter),
    sectionTracking: props.sectionTracking as Tracking,
    title: props.title || '',
    caption: props.caption || '',
    heading: props.heading || '',
    overlappingCTA: CTATransformer(props.overlappingCta) || undefined,
  };
}
